import axios, { AxiosRequestConfig } from "axios";
import { env } from "src/utils/env";

export const getBlogs = async (config?: AxiosRequestConfig) => {
  return await axios.get(`${env.BASE_MAGNOLIA_REST_URL}/delivery/blog`, {
    ...config,
    params: { ...config?.params, orderBy: "publish desc" },
  });
};

export const getBlog = async (slug: string) => {
  return await axios.get(`${env.BASE_MAGNOLIA_REST_URL}/delivery/blog/${slug}`);
};
